import { Button, DatePicker, Descriptions, Form, Modal, Spin } from "antd";
import { useEffect, useState } from "react";
import { teamStatistics } from "@/api/operation";
import dayjs from "dayjs";

export default function TeamPerformance(props: any) {
  const { open, onCancel, data } = props;
  const [form] = Form.useForm();
  const [formData, setFormData] = useState<any>({
    userId: "",
    startTime: dayjs().startOf('month').format("YYYY-MM-DD 00:00:00"),
    endTime: dayjs().endOf('month').format("YYYY-MM-DD 23:59:59"),
  });
  const [teamStatisticsData, setTeamStatisticsData] = useState<any>([
    {
      label: "团队购买设备量",
      dataIndex: "teamDeviceCount",
      key: "teamDeviceCount",
    },
    {
      label: "团队购买总金额",
      dataIndex: "teamPayAmountTotal",
      key: "teamPayAmountTotal",
    },
  ]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (data) {
      setFormData({
        ...formData,
        userId: data.userId,
      });
    }
  }, [data]);
  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        teamPerformance: [
          dayjs(formData.startTime),
          dayjs(formData.endTime),
        ],
      });
    } else {
      form.resetFields();
      setFormData({
        userId: "",
        startTime: dayjs().startOf("month").format("YYYY-MM-DD 00:00:00"),
        endTime: dayjs().endOf("month").format("YYYY-MM-DD 23:59:59"),
      });
    }
  }, [open]);

  useEffect(() => {
    if (formData.userId) {
      getTeamStatistics();
    }
  }, [formData]);

  const handleSearch = (values: any) => {
    setFormData({
      ...formData,
      startTime: dayjs(values[0]).format("YYYY-MM-DD 00:00:00"),
      endTime: dayjs(values[1]).format("YYYY-MM-DD 23:59:59"),
    });
  };

  const getTeamStatistics = async () => {
    try {
      setLoading(true);
      const { data } = await teamStatistics(formData);
      const list = teamStatisticsData?.map((item: any) => ({
        ...item,
        children: data?.[item.dataIndex] || 0,
      }));
      setTeamStatisticsData(list);
    } catch (error) {
      console.error("获取团队统计数据失败:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title="团队业绩"
      width={600}
      footer={null}
      destroyOnHidden
    >
      <div style={{ padding: "12px 6px" }}>
        <Form form={form}>
          <Form.Item label="业务时间范围" name="teamPerformance">
            <DatePicker.RangePicker onChange={handleSearch} />
          </Form.Item>
        </Form>
        <div style={{ marginTop: 24 }}></div>
        <Spin spinning={loading}>
          <Descriptions bordered items={teamStatisticsData} />
        </Spin>
      </div>
    </Modal>
  );
}
